(() => {
  const initializeGuide = (root) => {
    if (root.dataset.beginnerProductGuideInitialized === 'true') return;
    root.dataset.beginnerProductGuideInitialized = 'true';

    const links = [...root.querySelectorAll('[data-guide-anchor-link]')];
    if (!links.length) return;

    const setActiveLink = (anchorId) => {
      links.forEach((link) => {
        const isActive = link.dataset.guideAnchorLink === anchorId;
        link.classList.toggle('is-active', isActive);

        if (isActive) {
          link.setAttribute('aria-current', 'true');
        } else {
          link.removeAttribute('aria-current');
        }
      });
    };

    const initialAnchorId = decodeURIComponent(window.location.hash.slice(1));
    let activationEnabled = links.some((link) => link.dataset.guideAnchorLink === initialAnchorId);

    if (activationEnabled) {
      setActiveLink(initialAnchorId);
    }

    links.forEach((link) => {
      link.addEventListener('click', (event) => {
        const anchorId = link.dataset.guideAnchorLink;
        const target = document.getElementById(anchorId);
        if (!target) return;

        event.preventDefault();
        activationEnabled = true;
        setActiveLink(anchorId);
        target.scrollIntoView({
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          block: 'start',
        });
        window.history.replaceState(null, '', `#${anchorId}`);
      });
    });

    if (!('IntersectionObserver' in window)) return;

    const observer = new IntersectionObserver(
      (entries) => {
        if (!activationEnabled) return;

        const visibleEntry = entries
          .filter((entry) => entry.isIntersecting)
          .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];

        if (visibleEntry?.target.id) {
          setActiveLink(visibleEntry.target.id);
        }
      },
      {
        rootMargin: '-20% 0px -55% 0px',
        threshold: [0.05, 0.2, 0.5],
      }
    );

    root.querySelectorAll('[data-guide-anchor-section]').forEach((section) => {
      if (section.id) observer.observe(section);
    });
  };

  document.querySelectorAll('[data-beginner-product-guide]').forEach(initializeGuide);
})();
